import type { SegmentMst } from '@libs/domain';
import { MstImport, MstImportTmpl } from '@libs/templates/mst';
import type { PageProps } from '@ps-smart-cp/ppfw-client';
import { withRerender } from '@ps-smart-cp/ppfw-client';
import { useSegmentMstSettings } from './hooks';
import { importFunction } from './repositories';
import { createSegmentMstItemName } from './services';

function PageComponent({
  segmentMstKey,
  ...restProps
}: PageProps & Pick<SegmentMst['schema'], 'segmentMstKey'>) {
  const segmentMstSettings = useSegmentMstSettings();

  return (
    <MstImportTmpl
      mstName={createSegmentMstItemName(segmentMstKey, segmentMstSettings)}
      initMstImport={MstImport.baseInit}
      importFunction={importFunction(segmentMstKey)()}
      {...restProps}
    />
  );
}

export const Import = withRerender(PageComponent, 'Import');
